export default __webpack_public_path__ + "static/media/login_widget_vector.fed83037.svg";